<template>
    <form ref="aging_ranges_form" :id="formId" action="#" method="POST" @submit.prevent="onSubmit">

        <input type="hidden" name="_token" :value="csrf">

        <div class="form-group row mb-0 text-capitalize"
            v-if="hasRows()">
            <div class="col-md-5">
                <label><strong>{{ __('from') }}*</strong></label>
            </div>

            <div class="col-md-5">
                <label><strong>{{ __('to') }}*</strong></label>
            </div>
        </div>

        <component v-for="row in rows"
            :key="row.id"
            :is="row.element"
            :id="row.id"
            v-model="row.data"
            :initialFrom="row.data.from"
            :initialTo="row.data.to"
            @delete="deleteInterval"
            @change="updateRows" />

        <input type="hidden" name="currency_id" :value="currency">
        <input type="hidden" name="date" :value="date">

        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-6">
                        <div class="input-group">
                            <input type="number"
                                class="form-control"
                                v-model="intervalsToAdd"
                                style="max-width: 50px;"
                                v-if="!hasRows()">
                            <button type="button"
                                class="btn btn-sm btn-primary"
                                :class="!hasRows() ? 'm-l-xs' : ''"
                                @click="addIntervals">
                                {{ __('add_interval') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row m-t-sm">
            <div class="col-md-12">
                <label>
                    <input type="hidden" name="remember_aging_settings" :value="savedSettings">
                    <input type="checkbox" v-model="savedSettings"
                        :checked="savedSettings"
                        :true-value="true"
                        :false-value="false">
                    <strong>{{ __('remember_intervals') }}</strong>
                </label>
            </div>
        </div>
    </form>
</template>

<script>
    import FormInputsRow from './FormInputsRow'
    import { mapGetters } from 'vuex'

    export default {
        name: 'aging-ranges-form',
        components: {
            FormInputsRow,
        },
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            min: 0,
            max: 0,
            rows: [],
            rowsCount: 0,
            intervalsToAdd: 1,
            savedSettings: false
        }),
        props:{
            formId: String,
            currency: {
                default: null
            },
            date: {
                default: null
            },
            agingRange: {
                type: Object
            }
        },
        computed: {
            ...mapGetters({
                intervalsSettings: 'getIntervalsSettings',
            })
        },
        methods: {
            addIntervals() {
                if(this.rows.length == 0) {
                    for (let index = 0; index < this.intervalsToAdd; index++) {
                        this.addInterval()
                    }
                } else {
                   this.addInterval()
                }
            },
            addInterval(data = null) {
                this.rows.push({
                    id: this.rowsCount++,
                    element: FormInputsRow,
                    data: data ? {...data} : this.prepareData()
                })
            },
            prepareData() {
                let from = 0,
                to = this.rows[this.rows.length-1] != undefined ? this.rows[this.rows.length-1].data.to : this.max,
                fromReadonly = false

                if(this.rows.length == 0) {
                    from = this.min
                } else {
                    from = null
                    fromReadonly = true
                    this.rows[this.rows.length-1].data.to = null
                }
                return { 'from': from, 'fromReadonly': fromReadonly, 'to': to }
            },
            prepareDataFromItem(item) {
                let from = item.from,
                to = item.to,
                fromReadonly = this.rows.length == 0 ? false : true

                return { 'from': from, 'fromReadonly': fromReadonly, 'to': to }
            },
            deleteInterval(index) {
                let indexToDelete = this.rows.findIndex(x => x.id == index)

                if(indexToDelete == 0 && this.rows.length > 1) {
                    this.rows[indexToDelete+1].data.fromReadonly = false
                } else if(indexToDelete == this.rows.length-1 && this.rows.length > 1) {
                    this.rows[indexToDelete-1].data.to = this.max
                }
                else if(indexToDelete != 0){
                    this.rows[indexToDelete+1].data.from = this.rows[indexToDelete].data.from
                }

                this.$delete(this.rows, indexToDelete)
            },
            hasRows() {
                return this.rows.length > 0
            },
            updateRows(index, data) {
                let thisIndex = this.rows.findIndex(x => x.id == index),
                indexToChange = thisIndex+1

                if(thisIndex != this.rows.length-1 && data.to*1 >= this.rows[this.rows.length-1].data.to*1) {
                    data.to = this.rows[this.rows.length-1].data.to - 2
                }
                if(indexToChange <= this.rows.length-1) {
                    this.rows[indexToChange].data.from = data.to*1+1
                }
            },
            saveData() {
                let intervals = []
                this.rows.forEach(row => {
                    intervals.push({...row.data})
                })

                this.$store.dispatch('saveIntervals', {
                    'saved': this.savedSettings,
                    'intervals': intervals
                })
                this.$emit('closeModal')
            },
            onSubmit() {
                if(this.rows[0] != undefined && this.rows[0].data.from > this.min
                    || this.rows[this.rows.length-1] != undefined && this.rows[this.rows.length-1].data.to < this.max) {
                    let self = this;
                    this.$swal({
                        title: self.__("warning_!"),
                        text: self.__("documents_outside_designated_ranges_will_not_be_considered"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#55dd82",
                        confirmButtonText: self.__("ok"),
                        cancelButtonText: self.__("cancel"),
                        closeOnConfirm: true,
                        reverseButtons: true
                    }).then(result => {
                        if(result.value == true) {
                            this.saveData()
                        }
                    })
                } else {
                    this.saveData()
                }

            },
        },
        mounted () {
            if(this.intervalsSettings.intervals.length > 0) {
                this.intervalsSettings.intervals.forEach(element => {
                    this.addInterval(element)
                });
            }
            this.savedSettings = this.intervalsSettings.saved
            this.min = this.agingRange.min
            this.max = this.agingRange.max
        },
    }
</script>

<style scoped>
    .swal2-container{
        z-index: 2100 !important;
    }
</style>
